import React, { useEffect, useState } from 'react'
import { Container, Alert } from "react-bootstrap";

import FiltriReport from './FiltriReport';
import TabellaSede from './TabellaSede';
import TabellaServizio from './TabellaServizio';
import TabellaLavoratore from './TabellaLavoratore';
import { SpinnerComp } from '../helper/spinner';
import { buildUrl } from '../helper/handler';
import { getFromApi } from '../utilities/NetUtilities';

function ReportOrarioLavoro() {

    const [message, setMessage] = useState([])

    const [filter, setFilter] = useState(null);
    const [data, setData] = useState(null);

    const [urlCsvTabellaZona, setUrlCsvTabellaZona] = useState("")
    const [urlCsvTabellaLavoratore, setUrlCsvTabellaLavoratore] = useState("")
    const [urlCsvTabellaServizio, setUrlCsvTabellaServizio] = useState("")

    useEffect(() => {
        if (filter) {
            const organizzazioneMap = JSON.parse(window.sessionStorage.getItem("organizzazione"));
            const setMessageFromApi = (data) => {
                if (data.messaggi && data.messaggi[0]) {
                    setMessage(message => [...message, { tipo: data.messaggi[0].tipo, descrizione: data.messaggi[0].descrizione }]);
                }
                setData({});
            }
            if (organizzazioneMap) {
                setData(null);
                const params = {
                    organizzazione: organizzazioneMap.nome,
                    tipo: organizzazioneMap.tipo,
                    inizio: filter.inizio,
                    fine: filter.fine,
                    sede: filter.sede ? filter.sede : "",
                    lavoratore: filter.lavoratore ? filter.lavoratore : "",
                    servizio: filter.servizio ? filter.servizio : ""
                };
                const url = buildUrl('report', params);
                getFromApi(url, setData, setMessageFromApi);
                setUrlCsvTabellaZona(buildUrl('downloadReportCsv', Object.assign(params, { nometabella: "zona" })));
                setUrlCsvTabellaLavoratore(buildUrl('downloadReportCsv', Object.assign(params, { nometabella: "lavoratore" })));
                setUrlCsvTabellaServizio(buildUrl('downloadReportCsv', Object.assign(params, { nometabella: "servizio" })));
            }
        }
    }, [filter]);

    return <div className='main' role="main">
        <div>
            <h1 className="d-flex justify-content-center inEvidenza" id="title_home">Report</h1>
            {message && message.map((data, key) => (
                <Alert variant={data.tipo} id="message" key={key}>
                    {data.descrizione}
                </Alert>
            ))}
            <Container fluid>
                <FiltriReport setMessage={setMessage} onChange={setFilter} />
            </Container>
            {filter &&
                <Container fluid>
                    {data ? (
                        <div className='row space'>
                            <div className="col-lg-4 col-md-4">
                                <TabellaSede
                                    tabellaSede={data.tabellasede}
                                    minutiTotSede={data.totminutisede}
                                    urlCsv={urlCsvTabellaZona} />
                            </div>
                            <div className="col-lg-4 col-md-4">
                                <TabellaLavoratore
                                    tabellaLavoratore={data.tabellalavoratore}
                                    totMinutiLavoratore={data.totminutilavoratore}
                                    urlCsv={urlCsvTabellaLavoratore} />
                            </div>
                            <div className="col-lg-4 col-md-4">
                                <TabellaServizio
                                    tabellaServizio={data.tabellaservizio}
                                    minutiTotServizio={data.totminutiServizio}
                                    urlCsv={urlCsvTabellaServizio} />
                            </div>
                        </div>
                    ) : (
                        <SpinnerComp />
                    )}
                </Container>}
        </div>
    </div>
}

export default ReportOrarioLavoro;
